import gsap from '../utils/gsap-setup';

const init = () => {
  const block = document.getElementById('homepage-hero-animation');
  if(!block) return;

  // Get the height of the sticky navigation bar, to offset the scroll position
  const scaleFactor = 3;
  const viewportMax = Math.max(window.innerWidth, window.innerHeight);
  const targetSize = `${viewportMax * scaleFactor}px`;

  // The new GSAP variable to use.
  let mm = gsap.matchMedia();

  mm.add(
    {
      isDesktop: `(min-width: 1024px)`,
      isMobile: `(max-width: 759px)`,
      isTablet: `(min-width: 760px) and (max-width: 1023px)`,
      isReduceMotion: "(prefers-reduced-motion: reduce)",
    },
    (context) => {
      let { isMobile, isTablet } = context.conditions;

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: block,     // The element that starts the animation
          pin: true,            // Pin the trigger element while the timeline is active
          start: `top top`,     // Animation starts when the center of the trigger hits the center of the screen
          end: `+=${window.innerHeight * 2 }`,        // The pinning lasts for a scroll distance equal to the viewport height
          scrub: 0,             // Smoothly scrubs the animation in sync with the scrollbar (1-second lag)
          // markers: true,
          pinSpacing: false,
        }
      });

      // Fade out the hero content.
      timeline.to(".o-homepage-hero", {
        opacity: 0,
        duration: isMobile || isTablet ? 0.5 : 0.5,
        y: isMobile || isTablet ? -800 : -800,
        ease:"power2.out"
      });

      // This runs at the same time as the hero content fades out.
      timeline.to(".a-animated-scaling-diamond", {
        opacity: 1,
        duration: isMobile || isTablet ? 0.1 : 0.1
      }, "<");

      // Scales the diamond to cover the entire screen.
      // This will start right after the diamond becomes visible.
      timeline.to(".a-animated-scaling-diamond__shape", {
        width: targetSize,
        height: targetSize, // A large scale factor to ensure it covers the entire screen
        duration: isMobile || isTablet ? 0.2 : 0.8,
        force3D: false,
        ease: "power2.inOut"
      }, "<");
    });
}

export default init;
